import {Theme} from "@mui/material";
import {nunitoBase, palette, robotoBase} from "../../technical/style/theme";

export function muiDataTableTheme(outerTheme: Theme) {
  return {
    ...outerTheme,
    components: {
      ...outerTheme.components,
      MUIDataTable: {
        styleOverrides: {
          paper: {
            width: '100%',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            paddingLeft: outerTheme.spacing(2),
            paddingRight: outerTheme.spacing(2),
            ...nunitoBase
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          data: {
            ...robotoBase,
            ...palette.greyTextOpacity,
            fontSize: 12,
          },
        },
      },
      MUIDataTableBody: {
        styleOverrides: {
          emptyTitle: {
            ...palette.greyTextOpacity,
            ...robotoBase,
            fontSize: 14,
          },
        },
      },
      MuiTableBody: {
        styleOverrides: {
          root: {
            ...nunitoBase
          }
        }
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            cursor: 'pointer',
          }
        }
      },
      MUIDataTableToolbar: {
        styleOverrides: {
          root: {
            minHeight: 'unset',
          },
        },
      },
    }
  } as Theme
}
